import { render } from "./premiumService.vue?vue&type=template&id=30ec3262&scoped=true&ts=true"
import script from "./premiumService.vue?vue&type=script&lang=ts"
export * from "./premiumService.vue?vue&type=script&lang=ts"

import "./premiumService.vue?vue&type=style&index=0&id=30ec3262&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ec3262"]])

export default __exports__